<template>
  <a-modal
    :title="title"
    v-model:open="open"
    :confirm-loading="submitLoading"
    @ok="submitForm"
    @cancel="cancel"
  >
    <a-form ref="formRef" :model="form" :rules="rules">
      <a-form-item label="用户名" name="userName">
        <a-input v-model:value="form.userName" :disabled="true" />
      </a-form-item>
      <a-form-item has-feedback label="新密码" name="newPassword">
        <a-input-password
          v-model:value="form.newPassword"
          placeholder="请输入新密码"
          :maxLength="-1"
        />
      </a-form-item>
      <a-form-item has-feedback label="确认密码" name="confirmPassword">
        <a-input-password
          v-model:value="form.confirmPassword"
          placeholder="请确认密码"
          :maxLength="-1"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { resetUserPwd } from '@/api/system/user'

export default {
  name: 'ResetPassword',
  props: {},
  data() {
    const validateNewPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else if (
        !/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){5,20}$/.test(
          value
        )
      ) {
        callback(
          new Error(
            '请输入5-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种'
          )
        )
      } else {
        if (this.form.confirmPassword !== '') {
          this.$refs.formRef.validateFields(['confirmPassword'])
        }
        callback()
      }
    }
    const validateConfirmPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码确认'))
      } else if (value !== this.form.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      title: '重置密码',
      open: false,
      childrenDrawer: false,
      formLayout: 'horizontal',
      form: {
        userName: undefined,
        newPassword: undefined,
        confirmPassword: undefined,
      },
      rules: {
        newPassword: [
          { required: true, validator: validateNewPass, trigger: 'change' },
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPass, trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        userName: undefined,
        newPassword: undefined,
        confirmPassword: undefined,
      }
    },
    handleResetPwd(row) {
      this.form = {
        id: row.id,
        userName: row.userName,
      }
      this.open = true
    },
    /** 重置密码按钮操作 */
    submitForm: async function () {
      try {
        await this.$refs.formRef.validate()
        this.submitLoading = true
        await resetUserPwd(this.form.id, this.form.newPassword)
        this.$message.success('重置成功', 3)
        this.open = false
      } catch (error) {
        return false
      } finally {
        this.submitLoading = false
      }
    },
  },
}
</script>

<style>
/* Modal 按钮样式 */
.ant-modal-footer .ant-btn {
  border-radius: 4px !important;
}

.ant-modal-footer .ant-btn-primary {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.ant-modal-footer .ant-btn-primary:hover:not(:disabled) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.ant-modal-footer .ant-btn-default {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.ant-modal-footer .ant-btn-default:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
}
</style>
